import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { AddAuthorityComponent } from '../add-authority/add-authority.component';
import { AddAssetComponent } from '../add-asset/add-asset.component';
import { UserAssetComponent } from '../user-asset/user-asset.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AssetEmployeeEditComponent } from '../asset-employee-edit/asset-employee-edit.component';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { NewAssetEmployeeComponent } from '../new-asset-employee/new-asset-employee.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { calculateFiscalYear, formatYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { NewassetComponent } from 'src/app/newasset/newasset.component';
import { formatText } from 'src/app/shared/commen-function-file';
import { formatDate } from 'src/app/shared/commen-function-file';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ColDef, GridApi } from 'ag-grid-community';

export interface InnerTable {
  key: string;
  value: string;
}

export interface Item {
  name: string;
  details: string;
  additionalInfo1: string;
  additionalInfo2: string;
  innerTable: InnerTable[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-assest-management',
  templateUrl: './assest-management.component.html',
  styleUrls: ['./assest-management.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', minHeight: "*" })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AssestManagementComponent implements OnInit {
  selectedTypeTabName: any='Dashboard';
  selectedTypeTabIndex: any;
  buttonColorName: any;
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  loggedInUserName: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  originalData: any;
  showSetupPopup: boolean = false;
  competencyListManagerView: any;
  showImportPopup: boolean = false;
  selectedManagerDashboardId: boolean = false;
  selectedEmployeeDashboardId: any;
  selectedYearForCompetency: any = null;
  pmsYears: any = [];
  selectedUserId: any | null;
  gridApi: any;
  authorityGridApi: any;
  assetGridApi: any;
  comparisonEmpIdsForSecondLast: any = [];

  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];
  selectedYearForGraphOneHRAdmin: any = null;
  fromYear: any = null;
  toYear: any = null;
  assetSearchString: string = '';
  constructor(private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<AssestManagementComponent>,
    public mobileResponsiveService: MobileResponsiveService
  ) {
    this.groupAssetsByName();
  }
  ngOnInit() {


    this.cdRef.detectChanges();



    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;



    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    //  this.selectedTypeTabName= ( (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD') && !this.findLogdinUserAsaAuthority) ?'Asset': 'Dashboard'
     
    console.log("888888888", this.findLogdinUserAsaAuthority);


    // this.selectedTypeTabName = 
    // ((this.loggedInUserRole === 'Employee'   && this.findLogdinUserAsaAuthority) || 
    //  (this.loggedInUserRole === 'HOD' && this.findLogdinUserAsaAuthority)   || (this.loggedInUserRole === 'HOD' && !this.findLogdinUserAsaAuthority) ) 
    //   ? 'Asset' 
    //   : 'Dashboard';


    //  this.getSelectedTypeTabName();

    this.getpmsyearlist();

  }
   allocatingDepaabaleheader = [
    { label: 'Allocating Department', sortingName: 'assetDepartmentName' },
    { label: 'Employee Name', sortingName: 'employeeName' },
    { label: 'Action' },
  ];

  defaultColDef: ColDef = {
    sortable: true,
    resizable: true,
    flex: 1,
    minWidth: 150
  };
  gridOptions: any = {
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Allocating Department',
      field: 'assetDepartmentName',
      sortable: true,
      filter: true,
      // cellClass: 'cl-black fs-14 font_bold'
    },
    {
      headerName: 'Employee Name',
      field: 'employeeName',
      sortable: true,
      filter: true,
      // cellClass: 'cl-black fs-14 font_bold'
    },
    {
      headerName: 'Action',
      field: 'assetAuthorityId',
      cellRenderer: this.actionCellRenderer.bind(this),
      minWidth: 120,
    }
  ];
  onGridReady(params: any, gridType?: string) {
    if (gridType === 'authority') {
      this.authorityGridApi = params.api;
    } else if (gridType === 'asset') {
      this.assetGridApi = params.api;
    }
  }
  
  paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
  pagination = true;
  paginationPageSize = 10;
  isClicked = false;
  isAuthorityResetClicked = false;
  isAssetResetClicked = false;
 

  resetAssetGrid() {
    this.isAssetResetClicked = false;
  
    if (this.assetGridApi) {
      this.assetGridApi.setFilterModel(null);
      this.assetGridApi.deselectAll();
      this.assetSearchString = '';
      this.assetGridApi.setGridOption('quickFilterText', '');
      this.paginationPageSize = 10;
      this.assetGridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.assetGridApi.paginationGoToFirstPage();
      this.assetGridApi.refreshCells();
      this.assetGridApi.resetColumnState();
    }
  }
  
  resetAuthorityGrid() {
    this.isAuthorityResetClicked = false;
  
    if (this.authorityGridApi) {
      this.authorityGridApi.setFilterModel(null);
      this.authorityGridApi.deselectAll();
      this.searchTaskString = '';
      this.authorityGridApi.setGridOption('quickFilterText', '');
      this.paginationPageSize = 10;
      this.authorityGridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.authorityGridApi.paginationGoToFirstPage();
      this.authorityGridApi.refreshCells();
      this.authorityGridApi.resetColumnState();
    }
  }
  




  // 🔹 Action buttons inside AG Grid
  actionCellRenderer(params: any) {
    return `
      <img title="Edit" src="././assets/icon/edit.png"
        class="mr-5 cp imgdelete" width="25px" data-action="edit" />
      <span class="material-icons fs-20 red cp" data-action="delete">delete</span>
    `;
  }

  // 🔹 Capture click on action icons
  onCellClicked(event: any) {
    if (event.colDef.field === 'assetAuthorityId') {
      const action = event.event.target?.getAttribute('data-action');
      if (action === 'edit') {
        this.addAuthority(event.data);
      } else if (action === 'delete') {
        this.deleteAuthority(event.data.assetAuthorityId);
      }
    }
  }
  assettabaleheader = [
    { label: 'Asset Name', sortingName: 'assetName' },
    { label: 'Band', sortingName: 'bands' },
    { label: 'Authority Department', sortingName: 'authorityDepartment' },
    { label: 'Authority Name', sortingName: 'authorityName' },
    { label: 'Action' }
  ]
  columnDefsForAsset: ColDef[] = [
    { headerName: 'Asset Name', field: 'assetName', sortable: true,filter: true },
    { headerName: 'Band', field: 'bands', sortable: true, filter: true},
    { headerName: 'Authority Department', field: 'authorityDepartment', sortable: true, filter: true},
    { headerName: 'Authority Name', field: 'authorityName', sortable: true, filter: true},
    {
      headerName: 'Action',
      field: 'assetId',
      cellRenderer: this.actionCellRendererForAsset.bind(this),
      sortable: false,
      minWidth: 120
    }
  ];
   actionCellRendererForAsset(params: any) {
    return `
      <img title="Edit" src="././assets/icon/edit.png"
        class="mr-5 cp imgdelete" width="25px" data-action="edit" />
      <span class="material-icons fs-20 red cp" data-action="delete">delete</span>
    `;
  }

  // 🔹 Handle cell clicks (for edit/delete)
  onCellClickedForAsset(event: any) {
    if (event.colDef.field === 'assetId') {
      const action = event.event.target?.getAttribute('data-action');
      if (action === 'edit') {
        this.addAsset(event.data);
      } else if (action === 'delete') {
        this.deleteAasset(event.data.assetId);
      }
    }
  }






  getSelectedTypeTabName() {
    //this.selectedTypeTabName = ((this.loggedInUserRole === 'Employee' || this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') && this.findLogdinUserAsaAuthority) || (this.loggedInUserRole === 'Super Admin') ? 'Dashboard' : 'Asset';
    this.selectedTypeTabName = !(this.loggedInUserRole === 'Employee' || this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') ? 'Dashboard' : (this.loggedInUserRole === 'Employee'
      || this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') && this.findLogdinUserAsaAuthority ? 'Dashboard' : 'Asset';
  }

  formatedataVariable = formatText;
  strFormatDate = formatDate;

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    sessionStorage.setItem('selectedTypeTabName',this.selectedTypeTabName);
    sessionStorage.setItem('selectedTypeTabIndex',this.selectedTypeTabIndex);

  }
  selectedSubTabName:any='Inventory'
  selectedsubTabIndex:any;
  subtabTypeChanged(event: MatTabChangeEvent) {

    this.selectedSubTabName = event.tab.textLabel;
    this.selectedsubTabIndex = event?.index;
    

  }
  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/asset-management', { operation: operation }]);

  }

  onClickback() {
    this.router.navigate(['/home/hrportal/asset-management']);

  }



  ngAfterViewInit() {
    // Manually trigger change detection so selectedIndex gets applied after tab group renders
    this.cdRef.detectChanges();
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {

      var tab = params['tab'];
      if (tab === 'My Competency') {
        this.selectedTypeTabName = 'My Competency'
        this.selectedTypeTabIndex = 1;

      };

      if (params?.operation === 'Setup') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showSetupPopup = true;

          // this.getPmsYears();
        }
      } else if (params?.operation === 'import') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showImportPopup = true;
        }
      } else {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          // this.getDepartmentsByCompany();
        }
        else if (this.loggedInUserRole === 'Finance') {
          this.selectedManagerDashboardId = true; // Set up a manager-specific action
          // Call a manager-specific method if needed
        }

        else {
          this.selectedEmployeeDashboardId = this.loggedInUserId;
          // this.getUserByID();
        }

      }
    });
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);

      this.getAutorityListingData();
      this.getAllaseetListingData();
      this.assetAllocationData();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphSix = selectedYearObj?.year;
      this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
      this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }
  getYearSetupForReimbursement() {

    this.getAutorityListingData();
    this.getAllaseetListingData()
  }




  // ----------------------------------------------------Autory --------------------------------------------------

  autorityListData: any = [];
  addAuthority(event: any) {
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.height = '70%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width= window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '80%' : '70%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      autorityListData: this.autorityListData
    };

    const dialogRef = this.dialog.open(AddAuthorityComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAutorityListingData();
      this.getAllaseetListingData();
    });
  }
  // allocatingDepaabaleheader = [
  //   { label: 'Allocating Department', isMandatory: true, sortingName: 'assetDepartmentName' },
  //   { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
  //   { label: 'Action' },
  // ]


  getAutorityListingData() {
    this.httpService.callGetService(`${this.config.listingAssetAuthority}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        this.autorityListData = elm.data;
        console.log("-----------------------ssssssssss--------------",this.autorityListData);
        

      })

  }
  deleteAuthority(assetAuthorityId: any) {


    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you really want to delete this Allocating Department?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.httpService.callDeleteService(`${this.config.deleteAssetAuthority}/${assetAuthorityId}`).subscribe(
          (data: any) => {
            if (data) {
              // Success popup
              const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                // width: '30%',
                width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
                maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                data: {
                  msg: data.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });

              // Handle the result of the dialog
              dialogRef.afterClosed().subscribe(() => {
                console.log("After Delete");

                this.getAllaseetListingData();
                this.getAutorityListingData();
              });
            }
          },
          (error: any) => {

            const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              // width: '30%',
              width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: error.error.error || 'An error occurred while processing your request. Please try again.',
                btn2: 'OK',
                btn2BgColor: 'red', // Highlight error with red button color
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: true
              }
            });

            errorDialogRef.afterClosed().subscribe(() => {
              // Optionally handle any action after closing the error dialog
              console.log('Error dialog closed');
            });
          }
        );

      }
    });

  }
  // ----------------------------------------------------Autory --------------------------------------------------


  // ----------------------------------------------------Asset --------------------------------------------------

  // Asset Management



  addNewAssetEmployee(event: any) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '100%';
    // dialogConfig.width = '200vw';   // Try setting width to a smaller value
    dialogConfig.width= window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '80%' : '70%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      assetId: null,
      findLogdinUserAsaAuthority: this.findLogdinUserAsaAuthority
    };

    const dialogRef = this.dialog.open(NewAssetEmployeeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      console.log("enside Colse new Asset");
      this.assetAllocationData();
    });



  }
  AllAssetListingData: any = [];
  addAsset(event: any) {

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.height = '70%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '80%' : '70%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      assetId: null
    };

    const dialogRef = this.dialog.open(AddAssetComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAllaseetListingData();

    });



  }
  showAsset(event: any) {
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.height = '70%';
    // dialogConfig.width = '260vw'; // Responsive width
    dialogConfig.width= window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '90%' : '80%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    dialogConfig.disableClose = false; // Allows closing the dialog by clicking outside
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      assetId: event
    };

    const dialogRef = this.dialog.open(AddAssetComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      this.getAllaseetListingData();
    });
  }
  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/asset-logs', { moduleName: moduleName, id: 0 }]);
  }


  // assettabaleheader = [
  //   { label: 'Asset Name', isMandatory: true, sortingName: 'assetName' },
  //   { label: 'Band', isMandatory: true, sortingName: 'bands' },
  //   { label: 'Allocating Department', isMandatory: true, sortingName: 'authorityDepartment' },
  //   { label: 'Autority Name', isMandatory: true, sortingName: 'authorityName' },
  //   { label: 'Action' },
  // ]
  searchTaskString: string = '';

  isAuthorityClicked = false;
  isAssetClicked = false;
   
  
  

    // Helper: clear filters/sort/selection/quick filter/columns for a given grid API
    private clearGrid(api: any) {
      if (!api) return;

      try {
        api.setFilterModel && api.setFilterModel(null);
        if (typeof api.setSortModel === 'function') api.setSortModel(null);
        if (typeof api.deselectAll === 'function') api.deselectAll();
        this.searchTaskString = '';
        if (typeof api.setQuickFilter === 'function') api.setQuickFilter('');
        if (typeof api.refreshCells === 'function') api.refreshCells();
        if (typeof api.resetColumnState === 'function') api.resetColumnState();
      } catch (e) {
        console.warn('clearGrid: error clearing grid', e);
      }
    }

    // Called from authority section refresh button

    // Called from asset section refresh button

  getAllaseetListingData() {

    this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        this.AllAssetListingData = elm.data;
      })

  }

  // deleteAasset(assetId: any) {


  //   this.httpService.callDeleteService(`${this.config.deleteAsset}/${assetId}`).subscribe(
  //     (data: any) => {
  //       if (data) {
  //         // Success popup
  //         const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //           disableClose: true,
  //           height: '25%',
  //           // width: '30%',
  //           width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
  //           maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
  //           data: {
  //             msg: data.message,
  //             btn2: 'OK',
  //             btn2BgColor: this.buttonColorName,
  //             showSuccessIcon: true,
  //             showSuccessMessage: false,
  //             showCloseIcon: false
  //           }
  //         });

  //         // Handle the result of the dialog
  //         dialogRef.afterClosed().subscribe(() => {

  //           this.getAllaseetListingData();
  //         });
  //       }
  //     },
  //     (error: any) => {

  //       const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //         disableClose: true,
  //         height: '25%',
  //         // width: '30%',
  //         width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
  //         maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,

  //         data: {
  //           msg: error.error.error || 'An error occurred while processing your request. Please try again.',
  //           btn2: 'OK',
  //           btn2BgColor: 'red', // Highlight error with red button color
  //           showSuccessIcon: false,
  //           showSuccessMessage: false,
  //           showCloseIcon: true
  //         }
  //       });

  //       errorDialogRef.afterClosed().subscribe(() => {
  //         // Optionally handle any action after closing the error dialog
  //         console.log('Error dialog closed');
  //       });
  //     }
  //   );
  // }


  deleteAasset(assetId: any) {
    // Step 1: Ask for confirmation
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you really want to delete this Asset?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });
  
    // Step 2: If user confirms, call delete API
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.httpService.callDeleteService(`${this.config.deleteAsset}/${assetId}`).subscribe(
          (data: any) => {
            if (data) {
              // Step 3: Show success popup
              const successDialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
                maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                data: {
                  msg: data.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });
  
              successDialogRef.afterClosed().subscribe(() => {
                this.getAllaseetListingData();
              });
            }
          },
          (error: any) => {
            // Step 4: Show error popup
            const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: error.error.error || 'An error occurred while processing your request. Please try again.',
                btn2: 'OK',
                btn2BgColor: 'red',
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: true
              }
            });
  
            errorDialogRef.afterClosed().subscribe(() => {
              console.log('Error dialog closed');
            });
          }
        );
      }
    });
  }

  
  findLogdinUserAsaAuthority: any = false;
  checkDataForAuthority() {

    const filterEployeeId = this.AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId);

    if (filterEployeeId.length > 0) {
      this.findLogdinUserAsaAuthority = true;

      //  this.getSelectedTypeTabName();
    }
    sessionStorage.setItem('findLogdinUserAsaAuthority', this.findLogdinUserAsaAuthority);
  }
  // ---------------------------------------------------- End Asset --------------------------------------------------



  onCheckIconView = false;
  isFormDisabled = false;
  onClickIndividualScoreEdit() {
    this.onCheckIconView = true;
    this.isFormDisabled = true;
  }
  getScoreToFinalConverterIndividual() {

    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }
 

 
 
  // Sort order state


  deleteEmployee(id: any) {

  }




  selectedAssetName = '';
  displayedColumns: string[] = ['assetName'];
  employeeColumns: string[] = ['name', 'email'];



  // ------------------------------------------------------- laptop Assign ---------------------------------------------------------------------------------

  //  Laptop Assign Module
  userAsset(event: any) {
    
    if (event != null && !event?.users.some((user: any) => user?.userId !== null)) {
      console.log('Ignored: No valid userId found in event.users');
      return; // Exit if the condition is not met
    }

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.width= '100%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    // Try setting width to a smaller value
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: event?.users[0]?.userId || this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      userAssetDisable: 'userAssetDisable'
    };
    
    const dialogRef = this.dialog.open(UserAssetComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.assetAllocationData();
    });
  }



  NewAsset(event: any) {

    if (event != null && !event?.users.some((user: any) => user?.userId !== null)) {
      console.log('Ignored: No valid userId found in event.users');
      return; // Exit if the condition is not met
    }

    const dialogConfig = new MatDialogConfig();
    // dialogConfig.width= '100%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    
    // Try setting width to a smaller value
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      userAssetDisable: 'userAssetDisable'
    };
console.log("event in new asset------------------",dialogConfig);
    const dialogRef = this.dialog.open(NewassetComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.assetAllocationData();
    });
  }

  employeeAsset(event: any) {

    const SelectionTap = (this.loggedInUserRole == 'Employee' && !this.findLogdinUserAsaAuthority) ? 'Asset' : this.selectedTypeTabName;
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.height = '70%';
    // dialogConfig.width = '80%';   // Try setting width to a smaller value
    // dialogConfig.width = window.innerWidth <= 576 ? '100%' : '80%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
     dialogConfig.panelClass = 'phi_mdc_dialog__container_100';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: SelectionTap,
      selectedUserID: event?.userId || this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      assets: this.assets,
      data: event,
      authority: this.findLogdinUserAsaAuthority ? 'From Authority' : this.selectedTypeTabName == 'Asset' ? 'From Employee' : 'HR Admin'

    };

    const dialogRef = this.dialog.open(AssetEmployeeEditComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.assetAllocationData();
    });
  }



  originalAssets: any[] = [];
  assetAllocationFromAuthority: any = [];
  assetAllocationlistForEmployee: any = [];
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {

        this.originalAssets = elm.data;
        this.assetAllocationFromAuthority = elm.data;
        this.assetAllocationlistForEmployee = elm.data;
        this.groupAssetsByName();
        this.getDateByAuthorityName();
        this.getDateByEmployeeName();

        // this.groupEmployees();
      })

  }
  assets: any = [];

  // Group assets by asset name and merge users
  groupAssetsByName() {
    // Create a map to hold the grouped assets
    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.originalAssets) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: this.formatedataVariable(asset.authorityDepartmentComment),
          // Corrected property name
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: this.formatedataVariable(asset.employeeAssetStatus),
          employeeCommentDate: asset.employeeCommentDate,
          dateOfAllocation:asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          authorityCommentDate:asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: this.formatedataVariable(asset.authorityDepartmentComment),
            // Corrected property name
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: this.formatedataVariable(asset.employeeAssetStatus),
            employeeCommentDate:asset.employeeCommentDate,
            dateOfAllocation: asset.dateOfAllocation,
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate: asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.assets = Array.from(assetMap.values());
    console.log("this.assets-----------------------",this.assets);
    
  }






  deleteasset(id: any) {
    // Open confirmation dialog
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,

      data: {
        msg: 'Are you sure you want to delete this asset?',
        btn1: 'No',
        btn2: 'Yes',
        btn1BgColor: this.buttonColorName, // Set button colors if needed
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    // Handle user's response
    dialogRef.afterClosed().subscribe((result: any) => {

      if (result) {
        // User clicked "Yes"
        this.httpService
          .callDeleteService(`${this.config.deleteAssetFromEmployee}/${id}`)
          .subscribe((elm: any) => {

            if (elm) {
              const successDialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                // width: '30%',
                width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
                maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,

                data: {
                  msg: elm.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });
            }
            this.assetAllocationData(); // Refresh the data
          });
      } else {
        // User clicked "No"
        console.log('Delete action cancelled.');
      }
    });
  }

  //----------------------------------------------------------------------- Single Authority User----------------------------------------------------------------------------------------------

  allocateAuthority(event: any) {
    if (event != null && !event?.users.some((user: any) => user?.userId !== null)) {
      console.log('Ignored: No valid userId found in event.users');
      return; // Exit if the condition is not met
    }

    const dialogConfig = new MatDialogConfig();

    // Set to full-screen size
    // dialogConfig.height = '100%';
    // dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      operation: event ? "Update" : "Add",
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserId,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      findLogdinUserAsaAuthority: this.findLogdinUserAsaAuthority
    };
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh', 'mx-h60vh']; // Add a specific class for full-screen styles
console.log("event in allocateAuthority------------------",dialogConfig);
    const dialogRef = this.dialog.open(NewassetComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.assetAllocationData();
    });
  }




  allocatingAsset: any = [];
  getDateByAuthorityName() {

    this.assetAllocationFromAuthority = this.assetAllocationFromAuthority.filter((record: any) => record.authorityName == this.loggedInUserName);
    console.log("0000000000000000000000", this.assetAllocationFromAuthority)
    if (this.assetAllocationFromAuthority.length > 0) {
      this.findLogdinUserAsaAuthority = true;

      // if(this.loggedInUserRole === 'Employee'   && this.findLogdinUserAsaAuthority){
      //   this.selectedTypeTabName =   'Dashboard';
      // }
      // else if(this.loggedInUserRole === 'Manager' && this.findLogdinUserAsaAuthority){
      //   this.selectedTypeTabName =   'Dashboard';
      // } 
      // else if(this.loggedInUserRole === 'HOD' && this.findLogdinUserAsaAuthority){
      //   this.selectedTypeTabName =   'Dashboard';
      
      // }

      let selectedTypeTabName = sessionStorage.getItem('selectedTypeTabName');
      let selectedTypeTabIndex = sessionStorage.getItem('selectedTypeTabIndex');
      if(selectedTypeTabName){
        this.selectedTypeTabName = selectedTypeTabName;
        this.selectedTypeTabIndex = selectedTypeTabIndex;
      }else{
        this.selectedTypeTabName =
        (this.findLogdinUserAsaAuthority &&
          (this.loggedInUserRole === 'Employee' ||
            this.loggedInUserRole === 'Manager' ||
            this.loggedInUserRole === 'HOD'))
          ? 'Dashboard'
          : this.selectedTypeTabName;
      }
  
      

      console.log("------------------------------------", this.selectedTypeTabName);

      this.checkDataForAuthority();
      this.httpService.checkAuthorityName = this.findLogdinUserAsaAuthority;

    }


    this.selectedTypeTabName =
      (!this.findLogdinUserAsaAuthority &&
        (this.loggedInUserRole === 'Employee' ||
          this.loggedInUserRole === 'Manager' ||
          this.loggedInUserRole === 'HOD'))
        ? 'Asset'
        : this.selectedTypeTabName;


    // if (this.loggedInUserRole === 'Employee' && !this.findLogdinUserAsaAuthority) {
    //   this.selectedTypeTabName = 'Asset';
    // } else if (this.loggedInUserRole === 'HOD' && !this.findLogdinUserAsaAuthority) {
    //   this.selectedTypeTabName = 'Asset';
    // }
    // else if (this.loggedInUserRole === 'Manager' && !this.findLogdinUserAsaAuthority) {
    //   this.selectedTypeTabName = 'Asset';
    // }
    console.log("-----------------this.findLogdinUserAsaAuthority", this.findLogdinUserAsaAuthority)
    sessionStorage.setItem('findLogdinUserAsaAuthority', this.findLogdinUserAsaAuthority);
    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.assetAllocationFromAuthority) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: asset.authorityDepartmentComment,
          // Corrected property name
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: asset.employeeAssetStatus,
          employeeCommentDate: asset.employeeCommentDate,
          dateOfAllocation:asset.dateOfAllocation,
          // dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          authorityCommentDate: asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: asset.authorityDepartmentComment,
            // Corrected property name
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: asset.employeeAssetStatus,
            employeeCommentDate: asset.employeeCommentDate,
            // dateOfAllocation: asset.dateOfAllocation,
            dateOfAllocation: asset.dateOfAllocation,
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate:asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.allocatingAsset = Array.from(assetMap.values());

  }

  // ------------------------------------------------------------------------------My Asset -----------------------------------------------------------------------------------------------------
  allocatingAssetEmployee: any = [];

  allocatingEmployee: any = [];
  assetOptions = [
    "RECEIVED_ASSET",
    "REPAIR_ASSET",
    "RETURNING ASSET DUE TO EXIT",
    "RECEIVED AFTER REPAIR"
  ];
  updateAssetData(event: any) {

  }
  getDateByEmployeeName() {
    this.allocatingAssetEmployee = this.assetAllocationlistForEmployee.filter((record: any) => record.userId == this.loggedInUserId);
    console.log(this.allocatingAssetEmployee);

    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.allocatingAssetEmployee) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: asset.authorityDepartmentComment,
          // Corrected property name
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: asset.employeeAssetStatus,
          // employeeCommentDate: this.datePipe.transform(asset.employeeCommentDate, 'dd-MM-yy'),

          dateOfAllocation:asset.dateOfAllocation,
          // dateOfAllocation: this.datePipe.transform(asset.dateOfAllocation, 'dd-MM-yy'),

          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          // authorityCommentDate: this.datePipe.transform(asset.authorityCommentDate, 'dd-MM-yy')
          authorityCommentDate:asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          id: asset.id,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: this.formatedataVariable(asset.authorityDepartmentComment),
            // Corrected property name
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: this.formatedataVariable(asset.employeeAssetStatus),
            employeeCommentDate:asset.employeeCommentDate,
            dateOfAllocation: asset.dateOfAllocation,
            // dateOfAllocation: this.datePipe.transform(asset.dateOfAllocation, 'dd-MM-yy'),
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate:asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.allocatingEmployee = Array.from(assetMap.values());
    console.log(this.allocatingEmployee);


  }
  parentHeaders = [
    { key: 'assetName', label: 'Asset Name' },
    { key: 'bands', label: 'Band' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' }
  ];
  parentHeadersForEmployee = [
    { key: 'assetName', label: 'Asset Name' },
    { key: 'band', label: 'Band' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' }
  ];
  nestedHeaders = [
    { key: 'employeeName', label: 'Employee Name' },
    { key: 'band', label: 'Band' },
    { key: 'authorityDepartment', label: 'Authority Dept' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' },
    { key: 'dateOfAllocation', label: 'Allocation Date' },
    { key: 'currentAssetDescription', label: 'Current Asset Description' },
    { key: 'employeeAssetStatus', label: 'Employee Status' },
    { key: 'employeeComment', label: 'Employee Comment' },
    { key: 'employeeCommentDate', label: 'Employee Comment Date' },
    { key: 'authorityDepartmentComment', label: 'HR ADMIN/Allocating Authority Comment' },
    { key: 'authorityCommentDate', label: 'Authority Comment Date' },
    { key: 'assetRepairTime', label: 'Asset Repair Time' },
    { key: 'action', label: 'Action' },
  ];

  nestedHeadersForEmployee = [
    { key: 'employeeName', label: 'Employee Name' },
    { key: 'band', label: 'Band' },
    { key: 'authorityDepartment', label: 'Authority Dept' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' },
    { key: 'dateOfAllocation', label: 'Allocation Date' },
    { key: 'currentAssetDescription', label: 'Current Asset Description' },
    { key: 'employeeAssetStatus', label: 'Employee Status' },
    { key: 'employeeComment', label: 'Employee Comment' },
    { key: 'employeeCommentDate', label: 'Employee Comment Date' },
    { key: 'authorityDepartmentComment', label: 'HR ADMIN/Allocating Authority Comment' },
    { key: 'authorityCommentDate', label: 'Authority Comment Date' },
    { key: 'assetRepairTime', label: 'Asset Repair Time' },

  ];
  ngOnChanges() {
    // Re-filter assets if the data changes
  }



  filteredAssets: any = []
  searchTerm: string = '';
  searAssetsData: any = null;

  filterAssets(searchTerm: string) {
    const normalizedSearchTerm = searchTerm?.trim()?.toLowerCase();


    if (!normalizedSearchTerm) {
      if (this.searAssetsData) {
        this.assets = this.searAssetsData;
        this.searAssetsData = null;
      } else {
        this.assetAllocationData();
      }
      return;
    }


    if (!this.searAssetsData) {
      this.searAssetsData = JSON.parse(JSON.stringify(this.assets));
    }

    // Filter logic
    this.filteredAssets = this.searAssetsData.filter((asset: any) =>
      asset.users?.some((user: any) =>
        (user.assetName && user.assetName.toLowerCase().includes(normalizedSearchTerm)) ||
        (user.allocatingAuthorityName && user.allocatingAuthorityName.toLowerCase().includes(normalizedSearchTerm)) ||
        (user.bands && Array.isArray(user.bands) &&
          user.bands.some((band: string) => band.toLowerCase().includes(normalizedSearchTerm)))
      )
    );

    this.assets = this.filteredAssets;
    console.log(this.filteredAssets);
  }

}

